import { DEFAULT_SESSION, Session } from '@/models/session';
import { GTagEventData, gaPushEvent } from '@/utils/analytics';
import { createContext, Dispatch, SetStateAction } from 'react';

interface SessionContextProps {
  session: Session;
  setSession: Dispatch<SetStateAction<Session>>;
  refreshThreads: () => void;
  pushUserEvent: (action: string, data?: GTagEventData) => void;
}

const SessionContext = createContext<SessionContextProps>({
  session: DEFAULT_SESSION,
  setSession: () => ({}),
  refreshThreads: () => {},
  pushUserEvent: (action: string, data: GTagEventData = {}): void => {
    gaPushEvent(action, '', data);
  },
});

export default SessionContext;
